import { render, staticRenderFns } from "./uploadData.vue?vue&type=template&id=71787906&scoped=true"
import script from "./uploadData.vue?vue&type=script&lang=js"
export * from "./uploadData.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71787906",
  null
  
)

export default component.exports